import classNames from 'classnames'
import {Fragment} from 'react'

import type {Link} from './Breadcrumbs.types'
import BreadcrumbsLink from './BreadcrumbsLink/BreadcrumbsLink'

import styles from './Breadcrumbs.css'

type Props = {
  className?: string
  path: Link[]
}
export default function Breadcrumbs({className, path}: Props) {
  return (
    <div className={classNames(className, styles.breadcrumbs)}>
      {path.map((link, index) => (
        <Fragment key={link.name}>
          {index !== 0 ? <span className={styles.separator}>{'/'}</span> : null}
          <BreadcrumbsLink
            className={classNames({[styles.highlight]: index === path.length - 1})}
            {...link}
          />
        </Fragment>
      ))}
    </div>
  )
}
